import axios, { AxiosInstance } from 'axios';

export const prepareAuthHeaders = (): Record<string, string> => {
    const headers: Record<string, string> = {};
    headers['Content-Type'] = 'application/json';

    return headers;
};

const requestsHelper: AxiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': 'true',
    },
    withCredentials: true,
});

export default requestsHelper;
